import React, { useState } from 'react';
import LocationOnIcon from '@mui/icons-material/LocationOn';

const MapMarker = ({ taskTitle, empName, location, onClick }) => {
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = () => {
    setIsHovered(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
  };

  // Only show tooltip if both taskTitle and empName exist
  const shouldShowTooltip = taskTitle && empName;

  return (
    <div 
      onClick={onClick}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      style={{
        position: 'absolute',
        transform: 'translate(-50%, -50%)',
        cursor: 'pointer',
        color: 'red',
        fontSize: isHovered ? '28px' : '24px',
        transition: 'all 0.2s ease',
        zIndex: isHovered ? 1000 : 1
      }}
    >
      <LocationOnIcon 
        sx={{
          color: isHovered ? '#9404a7ff' : '#c300ffff',
          filter: isHovered ? 'drop-shadow(0 2px 4px rgba(0,0,0,0.3))' : 'none'
        }}
      />
      {isHovered && shouldShowTooltip && (
        <div style={{
          position: 'absolute',
          bottom: '100%',
          left: '50%',
          transform: 'translateX(-50%)',
          background: 'white',
          padding: '10px 12px',
          borderRadius: '6px',
          fontSize: '12px',
          color: 'black',
          minWidth: '140px',
          marginBottom: '8px',
          boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
          border: '1px solid #e0e0e0',
          textAlign: 'center',
          pointerEvents: 'none',
          zIndex: 1001,
          whiteSpace: 'nowrap'
        }}>
          {/* Layer 1: Task Title */}
          <div style={{
            fontWeight: 'bold',
            color: '#333',
            marginBottom: '4px',
            fontSize: '13px'
          }}>
            {taskTitle}
          </div>
          
          {/* Layer 2: Employee Name */}
          <div style={{
            color: '#666',
            marginBottom: location ? '4px' : '0',
            fontSize: '11px'
          }}>
            {empName}
          </div>
          
          {/* Layer 3: Location (only if it exists) */}
          {location && (
            <div style={{
              color: '#888',
              fontSize: '10px',
              fontStyle: 'italic'
            }}>
              {location}
            </div>
          )}
          
          {/* Arrow pointing down to marker */}
          <div style={{
            position: 'absolute',
            top: '100%',
            left: '50%',
            transform: 'translateX(-50%)',
            width: 0,
            height: 0,
            borderLeft: '6px solid transparent',
            borderRight: '6px solid transparent',
            borderTop: '6px solid white',
            pointerEvents: 'none'
          }} />
          <div style={{
            position: 'absolute',
            top: '101%',
            left: '50%',
            transform: 'translateX(-50%)',
            width: 0,
            height: 0,
            borderLeft: '7px solid transparent',
            borderRight: '7px solid transparent',
            borderTop: '7px solid #e0e0e0',
            pointerEvents: 'none'
          }} />
        </div>
      )}
    </div>
  );
};

export default MapMarker;